import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-controller-bar',
  templateUrl: './controller-bar.component.html',
  styleUrls: ['./controller-bar.component.scss']
})
export class ControllerBarComponent implements OnInit {
  [x: string]: any;

  itemsPerPage = [25, 50, 100];
  selectedItemsPerPage: number = 25;
  from: number = 1;
  to: number = 25;
  timer = null;

  @Output() onViewTypeChange = new EventEmitter();
  @Output() onChangedItemsPerPage = new EventEmitter();
  @Output() messagesSearchChange: EventEmitter<any> = new EventEmitter();
  activatedType = 'list'; // only to put active class on icon

  constructor(private snackBar: SnackbarService, private _snackBar: MatSnackBar) { }
  ngOnInit(): void {
  }

  setViewType(type: string) {
    this.onViewTypeChange.emit(type);
    this.activatedType = type;
  }

  changeRowsNumber(itemsPerPage) {
    this.selectedItemsPerPage = itemsPerPage;
    this.onChangedItemsPerPage.emit(itemsPerPage)
  }
  onKeyup($event) {
    const regex = '^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$';
    let foundError = $event.target.value.match(regex);
    if ($event.target.value === '' || foundError !== null) {
      // the search input is empty or doesnt has special chars
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.messagesSearchChange.emit($event.target.value);
      }, 1400)

    }
    else {
      this.snackBar.setSnackBarMessage(this.translate.instant('user-management.control-bar.special-warning'));
      this._snackBar.openFromComponent(SnackBarErrorComponent, {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
  }
}
